<template>
    <section class="employee-profile-view">
        <div class="container">
            <div class="header-section">
                <router-link to="/admin/employee-profile-type" class="back-button">
                    <img src="../../assets/images/arrow-left.svg" alt="arrow-left" />
                    <span>Back to Profile Types</span>
                </router-link>
                <div class="title-wrapper">
                    <h3 class="page-title">Employee <span class="highlight">Profile Type Details</span></h3>
                    <div class="status-badge" v-if="profileType.status">
                        {{ profileType.status }}
                    </div>
                </div>
            </div>

            <div class="profile-info">
                <div class="info-grid">
                    <div class="info-item">
                        <label>Profile Type</label>
                        <span class="value">{{ profileType.profile_type }}</span>
                    </div>
                    <div class="info-item">
                        <label>File</label>
                        <a class="file-link" @click="downloadProfileTypeFile(profileType.id, profileType.file)">
                            <i class="fas fa-file-download"></i>
                            {{ profileType.file }}
                        </a>
                    </div>
                    <div class="info-item" v-if="profileType.created_at">
                        <label>Created Date</label>
                        <span class="value">{{ formatDate(profileType.created_at) }}</span>
                    </div>
                    <div class="info-item" v-if="profileType.updated_at">
                        <label>Last Updated</label>
                        <span class="value">{{ formatDate(profileType.updated_at) }}</span>
                    </div>
                </div>
            </div>

            <div class="sections-container">
                <div class="section-card">
                    <Section1></Section1>
                </div>
                <div class="section-card">
                    <Section2></Section2>
                </div>
                <div class="section-card">
                    <Section3></Section3>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
/* eslint-disable */
import AppMixin from '../../mixins/AppMixin'
import Api from '../../router/api'
import { Vue2TinymceEditor } from "vue2-tinymce-editor";
import Section1 from "./Section1.vue";
import Section2 from "./Section2.vue";
import Section3 from './Section3.vue';

export default {
    name: 'EmployeeProfileTypeView',
    mixins: [AppMixin],
    data() {
        return {
            profileType: {}
        }
    },
    components: {
        Vue2TinymceEditor,
        Section1,
        Section2,
        Section3
    },
    methods: {
        getProfileType: function () {
            let that = this
            Api.getProfileType(this.$route.params.id).then(response => {
                that.profileType = response.data.res
            }).catch((error) => {
                this.$swal({
                    icon: "error",
                    title: "error",
                    text: error.response.data.message,
                    showConfirmButton: true
                }).then(function () {
                });
            });
        },
        formatDate(date) {
            if (!date) return '';
            return new Date(date).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        }
    },
    mounted() {
        this.getProfileType()
    }
}
</script>

<style scoped>
.employee-profile-view {
    padding: 2rem;
    background-color: #f8f9fa;
    min-height: 100vh;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    background: #ffffff;
    padding: 2rem;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.header-section {
    margin-bottom: 2.5rem;
    border-bottom: 1px solid #e9ecef;
    padding-bottom: 1.5rem;
}

.back-button {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    text-decoration: none;
    color: #6c757d;
    margin-bottom: 1.5rem;
    transition: all 0.3s ease;
    font-weight: 500;
}

.back-button:hover {
    color: #0056b3;
    transform: translateX(-5px);
}

.back-button img {
    width: 20px;
    height: 20px;
    transition: transform 0.3s ease;
}

.back-button:hover img {
    transform: translateX(-3px);
}

.title-wrapper {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.page-title {
    font-size: 2rem;
    color: #2c3e50;
    margin: 0;
    font-weight: 600;
}

.highlight {
    color: #0056b3;
    font-weight: 700;
}

.status-badge {
    background: #e3f2fd;
    color: #1976d2;
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-size: 0.875rem;
    font-weight: 500;
}

.profile-info {
    background: #f8f9fa;
    padding: 2rem;
    border-radius: 8px;
    margin-bottom: 2.5rem;
    border: 1px solid #e9ecef;
}

.info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
}

.info-item {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.info-item label {
    font-weight: 600;
    color: #495057;
    font-size: 0.875rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.value {
    color: #2c3e50;
    font-size: 1.125rem;
}

.file-link {
    color: #0056b3;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 1.125rem;
}

.file-link:hover {
    color: #003d82;
    transform: translateY(-2px);
}

.file-link i {
    font-size: 1.25rem;
}

.sections-container {
    display: grid;
    gap: 2rem;
}

.section-card {
    background: #ffffff;
    border-radius: 8px;
    padding: 1.5rem;
    border: 1px solid #e9ecef;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.section-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
    .employee-profile-view {
        padding: 1rem;
    }

    .container {
        padding: 1.5rem;
    }

    .header-section {
        padding-bottom: 1rem;
    }

    .page-title {
        font-size: 1.5rem;
    }

    .info-grid {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }

    .profile-info {
        padding: 1.5rem;
    }

    .section-card {
        padding: 1rem;
    }
}

/* Animation for content loading */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.container {
    animation: fadeIn 0.5s ease-out;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/EmployeeProfileTypeView.vue